// Loader.js
import React from "react";
import "./Loader.css"; // You can style your loader with CSS

const Loader = () => {
  return <div className="loader"></div>;
};

export default Loader;
